<script setup>
import {computed, watch, ref} from 'vue'

import Button from "@/common/Button.vue"
import {usePageContentDataStore} from '@/stores/pageContentData'
import {usePageEditorStore} from '@/stores/pageEditor'
import {useTemplatesStore} from '@/stores/templates'
import {useItemDataStore} from '@/stores/itemData'

const pageContentDataStore = usePageContentDataStore()
const pageEditorStore = usePageEditorStore()
const templatesStore = useTemplatesStore()
const itemDataStore = useItemDataStore()

const activePageContentId = computed(() => pageEditorStore.activePageContentId)
const pageContent = computed(() => pageContentDataStore.items?.find(o => o.id === activePageContentId.value))
const contentId = computed(() => pageContent.value?.contentId)

const content = ref(null)
watch(contentId, async (newId) => {
    if (newId) {
        content.value = await itemDataStore.get({
            tableName: 'content',
            id: newId
        })
    } else {
        content.value = null
    }
}, {immediate: true})

const contentTypeTitle = computed(() => {
    const contentTypes = templatesStore.contentTypes || []
    return contentTypes.find(o => o.id === content.value?.contentType)?.title
})

// Methods
const onMouseover = () => {
    pageEditorStore.hoverPageContentId = activePageContentId.value
}

const onMouseout = () => {
    pageEditorStore.hoverPageContentId = 0
}

const selectContent = async () => {
    pageEditorStore.scrollToContent({
        pageContentId: activePageContentId.value
    })

    pageEditorStore.leftSidebarActiveTab = 'Content'
}
</script>

<template>
    <div v-if="contentTypeTitle" class="d-inline">
        <i class="bi-chevron-compact-right mx-1 align-middle"/>

        <Button @mouseover="onMouseover" @mouseout="onMouseout" @click="selectContent"
                class="btn-sm lh-1 p-1">
            <small>{{ contentTypeTitle }}</small>
        </Button>
    </div>
</template>